import {
  gridGutter,
  gridGutterHalf,
  fontSize12,
  fontSize16,
  gridGutter1q1dot5,
  gridGutter1q3,
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";

import theme from "../../../../../js/shared/new-theme";

export const painelContent = `
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow: auto;
	z-index: 5;
`;

export const scrollMobile = `
	display: block;
	height: 100%;
	overflow: auto;
`;

export const totalFlex = `
	display: flex;
  flex-direction: column;

  .price-area--text {
    margin-left: 24px;
    margin-bottom: 8px;
  }
`;

export const buttonFlex = `
	display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const mobilePanel = (expectedGain = false) => `
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	background: ${theme.palette.common.white};
	position: fixed;
	top: 0;
	right: 0;
	left: 0;
	z-index: 9999;
	padding: 60px 0 ${expectedGain ? "114px" : "60px"};
	overflow: hidden;
  overflow: hidden; 
`;

export const mobilePanelHeader = `
  justify-content: space-between;
  padding: 14px;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 5;
  background: ${theme.palette.common.white};
  box-shadow: ${theme.shadows[200]};

  .go-back {
    color: ${theme.palette.gray[600].value};
    font-weight: bold;
  }
`;

export const mobilePanelFooter = `
  padding: ${gridGutterHalf}px ${gridGutter}px;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 4;
  background: ${theme.palette.common.white};
  align-items: center;
  flex-wrap: wrap;

  button {
    padding: 0;
    min-width: 128px;
    height: 36px;
    font-size: ${fontSize12};
    border-width: 1px;
    flex: 1;
    width: 100%;
  }
  &.finished {
    width: 100%;
    justify-content: center;
    padding: ${gridGutterHalf}px ${gridGutter + gridGutter1q1dot5}px;
    a {
      width: 100%;
      text-align: center;
    }
    button {
      width: 100%;
      max-width: 300px;
    }
	}
`;

export const quantMilesStyle = `
  .info { 
    display: flex;

    &-text {
      margin: 0 0 ${gridGutter1q3}px 0;
      font-size: ${fontSize12};
      font-weight: 600;
      span {
        color: ${theme.palette.gray[800].value};
        padding-right: ${gridGutter1q3}px;
      }
    }

    &-loading {
      display: inline-block;
    }
  }

  .average-separator {
    margin: ${gridGutter1q1dot5}px 0 ${gridGutter}px 0;
  }
`;

export const offerMilesStyle = `
  a {
		  color: ${theme.palette.gray[800].value};
    	cursor: pointer;
      text-decoration: underline;
  }

  .title {
    font-size: ${fontSize16};
    font-weight: bold;
    margin-bottom: ${gridGutter}px;
  }

  .quant-offer-miles {
    margin-bottom: ${gridGutterHalf}px;
    &--wrapper {
      margin: 0 0 ${gridGutterHalf}px 0;
      display: block;
    }
  }

  .average-offer-miles {
    &--wrapper {
      margin: 0 0 ${gridGutterHalf}px 0;
      display: block;
    }
  }

  .price-offer-miles {
    // margin-bottom: ${gridGutterHalf}px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${theme.palette.gray[400].value};
    &--wrapper {
      margin: 0 0 ${gridGutter1q3}px 0;
      display: block;
    }
    &--text {
      font-size: ${fontSize12};
      font-weight: 500;
      span {
        color: ${theme.palette.gray[800].value};
      }
    }
    &--loading {
      display: inline-block;
    }
  }

  .dynamic-range {
    padding: 16px 0 16px;
    border-bottom: 1px solid ${theme.palette.gray[400].value};
    display: flex;
    align-items: center;
    justify-content: space-between;
    i {
      color: ${theme.palette.gray[600].value};
    }
  }

  .miles-reduction-tickets {
    margin: ${gridGutterHalf}px 0;
  }   

  .show-advanced-settings {
    &--label {
      font-size: ${fontSize12};
      font-weight: normal;
    }
  }

  .check-smiles-diamond {
    &--wrapper {
      margin: ${gridGutterHalf}px 0;
    }
    &--separator {
      margin-top: -12px;
    }
    &--label {
      font-size: ${fontSize12};
      font-weight: normal;
      strong {
        color: ${theme.palette.gray[800].value};
      }
    }
  }
`;

export const loadingStyle = `
	display: flex;
	justify-content: center;
	padding: 64px 0;
	width: 100%;
`;

export const stepContent = `
	display: flex;
	width: 100%;
	padding: 0 24px;
	flex-direction: column;
`;

export const header = `
	width: 100%; 
	padding: 16px 0;
	font-size: ${fontSize16};
  color: ${theme.palette.gray[800].value}
`;

export const singleInput = `
	width: 100%; 
	padding: 16px 0;
	font-size: 14px;
`;

export const buttonPhone = `
	font-size: 14px;
	margin: 8px 0;
  padding: 12px 16px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    color: ${theme.palette.common.white};
  }
`;

export const padding15TopBottom = `
	padding: 15px 0;
`;

export const bonusStyle = `
  padding: ${gridGutter1q1dot5}px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

	p {
		color: ${theme.palette.gray[600].value};
		font-weight: 800;
    margin: 0;

		span {
			border-radius: 4px;
			background-color: ${theme.palette.red[100].value};
			color: ${theme.palette.common.white};
			padding: 3px 8px;
			font-size: 12px;
			font-weight: 600;
			text-transform: none;
			margin-left: 5px;
		}
  }
  
  .offers-arrow-right {
    color: ${theme.palette.gray[600].value};
  }
`;

export const phoneCheck = `
  display: flex;
  gap: 4px;
  padding-top: 3px;
  font-size: 12px;

  i {
    color: ${theme.palette.green[600].value};
  }
`;

export const title = `
  color: ${theme.palette.gray[700].value}
`
